var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "profile-avatar-wrapper" },
    [
      _c(
        "v-avatar",
        {
          attrs: { color: "#e0e0e0", size: "60" },
          on: {
            click: function($event) {
              return _vm.$emit("click")
            }
          }
        },
        [
          _vm.userName !== "Add New"
            ? _c("div", { staticClass: "profile-avatar-initials" }, [
                _vm._v(
                  "\n      " + _vm._s(_vm.initialsFromUsername()) + "\n    "
                )
              ])
            : _c("v-icon", { attrs: { color: "#bdbdbd", dense: "" } }, [
                _vm._v(" mdi-plus-thick ")
              ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "user-wrapper",
          on: {
            click: function($event) {
              return _vm.$emit("click")
            }
          }
        },
        [
          _c("div", { staticClass: "user-profile-container" }, [
            _vm._v(_vm._s(_vm.userName))
          ]),
          _vm._v(" "),
          _vm.email
            ? _c("div", { staticClass: "user-profile-container" }, [
                _vm._v(_vm._s(_vm.email))
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticStyle: { display: "flex" } }, [
            _vm.shareStatus
              ? _c("div", { staticClass: "user-profile-container" }, [
                  _vm._v("\n        " + _vm._s(_vm.shareStatus) + "\n      ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.shareExpireDate
              ? _c("div", { staticClass: "user-profile-container" }, [
                  _vm._v(
                    "\n         - Exp. " +
                      _vm._s(_vm.shareExpireDate) +
                      "\n      "
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.userName !== "Add New"
            ? _c(
                "div",
                {
                  staticClass: "remove-container",
                  on: {
                    click: function($event) {
                      return _vm.$emit("btnClick")
                    }
                  }
                },
                [_vm._v("\n      Remove\n    ")]
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }